import { render, staticRenderFns } from "./AppAlertsCoaAlertsConfigSimple.vue?vue&type=template&id=75ec5efa&scoped=true&"
import script from "./AppAlertsCoaAlertsConfigSimple.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaAlertsConfigSimple.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaAlertsConfigSimple.vue?vue&type=style&index=0&id=75ec5efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec5efa",
  null
  
)

export default component.exports